export enum RouterDirection {
  from = 'from',
  to = 'to',
}
